import trackEvent from '@/common/js/track.js'

// loading完成有数据返回是才曝光
export function homepageTaskCenterLandingSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_center_landing_sw',
    eventLabel: '首页任务中心落地页曝光',
    attrs,
    callback
  })
}

// 任务中心规格点击时触发
export function homepageTaskCenterRuleCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_center_rule_ck',
    eventLabel: '首页任务中心规格点击',
    attrs,
    callback
  })
}

// 首页任务中心券的实曝光
export function homepageTaskCouponRealexposureSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_coupon_realexposure_sw',
    eventLabel: '首页任务中心券的实曝光',
    attrs,
    callback
  })
}

// 任务中心进度条滑动动作导致新的任务节点透出时触发
export function homepageTaskOrderSlideCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_order_slide_ck',
    eventLabel: '任务中心进度条滑动动作导致新的任务节点透出时触发',
    attrs,
    callback
  })
}

// 任务中心按钮点击
export function homepageTaskOrderButtonCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_order_button_ck',
    eventLabel: '首页任务中心按钮点击',
    attrs,
    callback
  })
}

// 任务中心其他活动位(目前只有Cgc)点击
export function homepageTaskActivityCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_activity_ck',
    eventLabel: '任务中心其他活动位(目前只有Cgc)点击',
    attrs,
    callback
  })
}
// 任务中心落地页-自动领取奖励弹窗
export function homepageTaskCouponRedenvelopeSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_coupon_redenvelope_sw',
    eventLabel: '任务中心落地页-自动领取奖励弹窗',
    attrs,
    callback
  })
}

// 任务中心落地页-自动领取奖励弹窗点击order
export function homepageTaskCouponRedenvelopeCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_coupon_redenvelope_ck',
    eventLabel: '任务中心落地页-自动领取奖励弹窗点击order',
    attrs,
    callback
  })
}

// 任务中心落地页-点击奖励节点
export function homepageTaskCouponTaskCk (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_coupon_task_ck',
    eventLabel: '任务中心落地页-点击奖励节点',
    attrs,
    callback
  })
}

// 任务中心落地页-条件已达成弹窗
export function homepageTaskCouponCompleteSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_coupon_complete_sw',
    eventLabel: '任务中心落地页-条件已达成弹窗',
    attrs,
    callback
  })
}


// 任务中心落地页-空任务兜底页的曝光
export function homepageTaskCenterNoneSw (attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_homepage_task_center_none_sw',
    eventLabel: '任务中心落地页-空任务兜底页的曝光',
    attrs,
    callback
  })
}